import React, { useEffect } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import BusinessIcon from '@mui/icons-material/Business';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { dashboardAction } from '_actions'
import { makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles';
import theme from './../../../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  title: {
    fontWeight: 500,
    color: '#FFF'
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#FFC107',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardOrgaosPendentes = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const orgaosPendentes = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.orgaosPendentes : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent sx={{
        backgroundColor: '#25261C'
      }}>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {orgaosPendentes ? orgaosPendentes : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" gutterBottom sx={{ color: '#FFF' }}>
                Órgãos aguardando aprovação
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <BusinessIcon sx={{ fontSize: 25, color: '#000' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardOrgaosPendentes.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardOrgaosPendentes
